import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9\-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const numberFormats = {
  'en-CA': {
    currency: {
      style: 'currency',
      currency: 'CAD',
      currencyDisplay: 'symbol',
    },
    currencyDollars: {
      style: 'currency',
      currency: 'CAD',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    number: {},
    percent: {
      style: 'percent',
    },
    percent2FractionDigits: {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  'fr-CA': {
    currency: {
      style: 'currency',
      currency: 'CAD',
      currencyDisplay: 'symbol',
    },
    currencyDollars: {
      style: 'currency',
      currency: 'CAD',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    number: {},
    percent: {
      style: 'percent',
    },
    percent2FractionDigits: {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
};

let userLanguage = navigator.language || 'en_CA';
if (userLanguage === 'en-CA') {
  userLanguage = 'en_CA';
} else if (userLanguage === 'fr-CA' || userLanguage === 'fr') {
  userLanguage = 'fr_CA';
} else {
  userLanguage = 'en_CA';
}

const i18n = createI18n({
  legacy: false, // Use the Composition API mode (recommended for Vue 3)
  globalInjection: true, // Enable global properties injection (injects $t, $n …)
  locale: userLanguage,
  fallbackLocale: window.envVars?.VUE_APP_I18N_FALLBACK_LOCALE || 'en_CA',
  messages: loadLocaleMessages(),
  numberFormats,
  warnHtmlMessage: false, // Suppress HTML in message warnings (we use vue-html-secure)
});

// ---------------------------------------------------------------------------
// Patch $n / i18n.global.n to coerce its first argument to a Number and avoid
// vue-i18n "INVALID_ARGUMENT" errors when the value is null, undefined or a
// numeric string coming from the API. This keeps template code unchanged while
// making the formatter more resilient.
// ---------------------------------------------------------------------------

// Keep original reference
const rawNumberFormatter = i18n.global.n.bind(i18n.global);

// Override with safe wrapper
i18n.global.n = (value, ...rest) => {
  const num = Number(value);
  if (Number.isFinite(num)) {
    return rawNumberFormatter(num, ...rest);
  }
  // Return empty string for invalid numbers to avoid template errors
  return '';
};

export default i18n;
